import type { Namespace, TFunction } from 'i18next'

import type {
  BaseIssueCode,
  BaseValidationRule,
  CustomValidationRule,
  ErrorMapContext,
  TypedBaseZodIssue,
  TypedZodCustomIssue,
  ValidationRule,
} from './types.ts'

export function createErrorMapRule<
  TCode extends BaseIssueCode,
  TNamespace extends Namespace,
>(
  issueCode: TCode,
  t: TFunction<TNamespace>,
  rule: BaseValidationRule<TCode, TNamespace>
) {
  return ((issue: TypedBaseZodIssue<TCode>, context: ErrorMapContext) => {
    if (issue.code === issueCode) {
      return rule(issue, context, t)
    }

    return null
  }) as ValidationRule
}

export function createCustomErrorMapRule<TCode extends Record<string, unknown>>(
  rule: CustomValidationRule<TCode>
) {
  return ((issue: TypedZodCustomIssue<TCode>, context: ErrorMapContext) => {
    if (issue.code === 'custom') {
      return rule(issue, context)
    }

    return null
  }) as ValidationRule
}
